export const pluralize = (count, word, plural) => {
  return `${count} ${count === 1 ? word : plural || `${word}s`}`;
};
